import { useState } from "react";
import { CalendarCheck, QrCode, Star, ShoppingBag, Disc3, Flag, Gift, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { DemoRenderer } from "@/advisor/demos/DemoRenderer";
import { Disclaimer } from "@/advisor/Disclaimer";

const ITEMS = [
  { type: "booking", title: "Online rezervasiya", d: "Xidmət, tarix və saat seçimi", Icon: CalendarCheck },
  { type: "race", title: "TikTok Race", d: "Hədiyyələrlə maşın yarışı", Icon: Flag, live: true },
  { type: "wheel", title: "TikTok Çarx", d: "Hədiyyə gələndə çarx fırlanır", Icon: Disc3, live: true },
  { type: "giftbox", title: "TikTok Gift Box", d: "Hədiyyə topla, qutunu aç", Icon: Gift, live: true },
  { type: "qr", title: "QR Loyalty", d: "Səfər və bonus kartı", Icon: QrCode },
  { type: "reviews", title: "Review System", d: "Google rəylərini artırmaq", Icon: Star },
  { type: "order", title: "Online sifariş", d: "Menyudan sifariş", Icon: ShoppingBag },
];

export const DemoGallery = () => {
  const [open, setOpen] = useState(null);
  return (
    <section id="demo" className="container-lm py-20 scroll-mt-20" data-testid="demos-page">
      <div className="eyebrow mb-3">Demo</div>
      <h1 className="font-display text-3xl sm:text-4xl font-semibold">Funksiyaları sına</h1>
      <p className="text-[#77736B] mt-3 max-w-xl">Biz funksiyanı nümayiş etdiririk, gələcək dizaynı yox.</p>
      <div className="mt-5 max-w-xl"><Disclaimer /></div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
        {ITEMS.map((it) => (
          <button key={it.type} onClick={() => setOpen(it)} className="group text-left rounded-2xl bg-white/70 border border-[#171715]/5 p-6 transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-[0_24px_50px_-30px_rgba(23,23,21,.35)]" data-testid={`demo-tile-${it.type}`}>
            <div className="flex items-center justify-between">
              <span className="h-12 w-12 rounded-xl bg-[#EEE7DC] grid place-items-center transition-colors group-hover:bg-[#171715] group-hover:text-[#D6AD62]"><it.Icon className="h-6 w-6" /></span>
              {it.live && <span className="text-[10px] font-bold bg-[#171715] text-[#F3D592] px-2 py-1 rounded-full">TikTok LIVE</span>}
            </div>
            <div className="font-display text-lg font-semibold mt-4">{it.title}</div>
            <div className="text-sm text-[#77736B]">{it.d}</div>
            <div className="text-sm font-semibold text-[#b58a3f] mt-4 flex items-center gap-1 group-hover:gap-2 transition-all">Sına <ArrowRight className="h-4 w-4" /></div>
          </button>
        ))}
      </div>

      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-lg max-h-[92vh] overflow-y-auto bg-[#151513] text-[#F3EEE4] border-white/10" data-testid="demo-modal">
          <DialogHeader><DialogTitle className="font-display text-xl">{open?.title}</DialogTitle></DialogHeader>
          {open && <DemoRenderer type={open.type} />}
          <Disclaimer />
        </DialogContent>
      </Dialog>
    </section>
  );
};
